import { makeAutoObservable, runInAction, toJS } from "mobx";
import ApiData from "./ApiData";
import RolesState from "./RolesState";
import User from "./User";
import Media from "./Media";
import ReportData from "./ReportData";
import stateUtils from "../utils/state.utils";
import {
  ALERT_SHOW_MINE_ONLY_KEY,
  filterSubscriptionAlerts,
  HIDE_EXPIRED_SUBSCRIPTION_ALERT_KEY,
} from "../utils/subscriptionAlertUtils";
import { readSystemMessagesSession } from "../utils/systemMessagesSessionStorage";
import { setOnSystemMessageLogged } from "./systemMessageNotify";

export const SYSTEM_WRITE_MESSAGES_FILTER = "system_write_messages";

class alert {
  alert_loader = true;
  cls_visible_alert = "hidden"; //Класс колокольчика уведомлений
  counter_error_supscription = 0; // Число ошибок по лицензиям
  // counter_error_defect = 0; // Число ошибок по проценту брака
  date_error_subscription = []; // Число ошибок по проценту брака
  date_error_defect = []; // Число ошибок по проценту брака
  active_report_subscription =
    localStorage.getItem("active_report_subscription") === "false"
      ? false
      : true;
  active_report_defect =
    localStorage.getItem("active_report_defect") === "false" ? false : true;
  hide_expired_subscription_alert =
    localStorage.getItem(HIDE_EXPIRED_SUBSCRIPTION_ALERT_KEY) === "true";
  alert_show_mine_only =
    localStorage.getItem(ALERT_SHOW_MINE_ONLY_KEY) === "true";
  counter_error = 0; // Общее число ошибок
  filter_collection = [];
  /** @type {Promise<void> | null} */
  calcErrorInFlight = null;

  constructor() {
    makeAutoObservable(this, { calcErrorInFlight: false });
    setOnSystemMessageLogged(() => this.recalculateCounterError());
  }

  to_defect_report_date = "";
  from_defect_report_date = "";

  setParameters = (name, value) => {
    this[name] = value;
  };

  syncHideExpiredFromStorage = () => {
    runInAction(() => {
      this.hide_expired_subscription_alert =
        localStorage.getItem(HIDE_EXPIRED_SUBSCRIPTION_ALERT_KEY) === "true";
    });
    this.recalculateCounterError();
  };

  syncAlertShowMineOnlyFromStorage = () => {
    runInAction(() => {
      this.alert_show_mine_only =
        localStorage.getItem(ALERT_SHOW_MINE_ONLY_KEY) === "true";
    });
  };

  setAlertShowMineOnly = (value) => {
    runInAction(() => {
      this.alert_show_mine_only = value;
      localStorage.setItem(
        ALERT_SHOW_MINE_ONLY_KEY,
        value ? "true" : "false",
      );
    });
    this.recalculateCounterError();
  };

  recalculateCounterError = () => {
    runInAction(() => {
      let total = 0;
      for (const tag of this.filter_collection) {
        if (!tag.visible || !tag.active) {
          continue;
        }
        if (tag.name === "active_report_subscription") {
          total += filterSubscriptionAlerts(this.date_error_subscription, {
            hideExpired: this.hide_expired_subscription_alert,
            showMineOnly: this.alert_show_mine_only,
            searchQuery: "",
            currentUserId: User.user?.id,
            companys: ApiData.companys,
          }).length;
        } else if (tag.name === SYSTEM_WRITE_MESSAGES_FILTER) {
          total += readSystemMessagesSession().length;
        } else if (tag.nameData && Array.isArray(this[tag.nameData])) {
          total += this[tag.nameData].length;
        }
      }
      this.counter_error = total;
    });
    this.checkVisibleIconAlert();
  };

  resetOnLogout = () => {
    runInAction(() => {
      this.counter_error = 0;
      this.counter_error_supscription = 0;
      this.date_error_subscription = [];
      this.filter_collection = [];
      this.cls_visible_alert = "hidden";
      this.alert_loader = true;
    });
  };

  incrementCounterError = (name) => {
    this.counter_error = this.counter_error + name;
  };

  decrementCounterError = (name) => {
    this.counter_error = this.counter_error - name;
  };

  addItemFilterCollection = (date, name, nameRU, nameData) => {
    if (date.length === 0) {
      return;
    }
    const item = {
      name,
      nameRU,
      active: true,
      visible: localStorage.getItem(name) === "false" ? false : true,
      nameData,
    };
    const existingIndex = this.filter_collection.findIndex((t) => t.name === name);
    if (existingIndex >= 0) {
      this.filter_collection[existingIndex] = item;
    } else {
      this.filter_collection = [...this.filter_collection, item];
    }
  };

  ensureSystemMessagesFilter = () => {
    const name = SYSTEM_WRITE_MESSAGES_FILTER;
    const existingIndex = this.filter_collection.findIndex((t) => t.name === name);
    const hasSubscriptionTab = this.filter_collection.some(
      (t) => t.name === "active_report_subscription",
    );
    const item = {
      name,
      nameRU: "Уведомления системы",
      active: existingIndex >= 0 ? this.filter_collection[existingIndex].active : !hasSubscriptionTab,
      visible: true,
      nameData: null,
    };
    if (existingIndex >= 0) {
      this.filter_collection[existingIndex] = item;
    } else {
      this.filter_collection = [...this.filter_collection, item];
    }
  };

  setVisibleTagFilterCollection = (tag) => {
    const tagID = this.filter_collection.find((t) => t.name === tag.name);
    if (tagID) {
      // tagID.active = !tagID.active;
      tagID.visible = localStorage.getItem(tag.name) === "false" ? false : true;
      this.setParameters(
        tag.name,
        localStorage.getItem(tag.name) === "false" ? false : true,
      );
      this.recalculateCounterError();
    }
  };

  setActiveTagFilterCollection = (tag) => {
    runInAction(() => {
      for (const t of this.filter_collection) {
        t.active = t.name === tag.name;
      }
    });
    this.recalculateCounterError();
  };

  reportPercentDefect = async () => {
    // const newDate = new Date();
    this.from_defect_report_date = new Date();
    this.to_defect_report_date = new Date();
    this.from_defect_report_date.setDate(
      this.from_defect_report_date.getDate() - 14,
    );
    const res = await ApiData.getDataCompanys();
    if (res) {
      const resReport = await ReportData.reportSerialisation(
        ApiData.companys,
        stateUtils.dateYYYYMMDD(this.from_defect_report_date),
        stateUtils.dateYYYYMMDD(this.to_defect_report_date),
      );
      if (resReport) {
        return resReport.filter((item) => item.percent >= 5);
      }
    }
  };

  getSubscription = async () => {
    if (localStorage.getItem("User") === null) return;
    if (RolesState.subscription_rights || User.user.is_superuser) {
      const res = await ApiData.allReportSubscription(15);
      if (res) {
        return res;
      }
    }
    return [];
  };

  checkVisibleIconAlert = () => {
    if (this.counter_error > 0) {
      runInAction(() => {
        this.cls_visible_alert = !Media.mobile
          ? "header_alert"
          : "header_alert_mobile";
      });
    } else {
      runInAction(() => {
        this.cls_visible_alert = "hidden";
      });
    }
  };

  updateFilterTag = (e) => {
    const filterID = this.filter_collection.find((f) => e.name === f.name);
    if (filterID) {
      filterID.active = !filterID.active;
    }
  };

  //   Расчёт всех ошибок в ЛК
  calcError = () => {
    if (this.calcErrorInFlight) {
      return this.calcErrorInFlight;
    }
    this.calcErrorInFlight = this.runCalcError().finally(() => {
      this.calcErrorInFlight = null;
    });
    return this.calcErrorInFlight;
  };

  runCalcError = async () => {
    try {
      runInAction(() => {
        this.counter_error = 0;
        this.counter_error_supscription = 0;
        this.filter_collection = [];
        this.alert_loader = true;
      });

      if (
        RolesState.companys &&
        (!ApiData.companys || ApiData.companys.length === 0)
      ) {
        await ApiData.getDataCompanys();
      }

      const subscriptionList = await this.getSubscription();
      const list = Array.isArray(subscriptionList) ? subscriptionList : [];

      runInAction(() => {
        this.date_error_defect = [];
        this.date_error_subscription = list;
        this.counter_error_supscription = list.length;

        if (list.length !== 0) {
          this.addItemFilterCollection(
            list,
            "active_report_subscription",
            "Подписки",
            "date_error_subscription",
          );
        }

        this.ensureSystemMessagesFilter();
      });

      this.recalculateCounterError();
      runInAction(() => {
        this.alert_loader = false;
      });
    } catch (e) {
      console.error(e);
      runInAction(() => {
        this.alert_loader = false;
      });
    }
  };
}

export default new alert();
